import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import buyingGuides from '../data/buyingGuides.json';
import Header from '../componentes/Header';
import Footer from '../componentes/Footer';
import { APPLE_THEME, TYPOGRAPHY } from '../theme';
 
const SectionIcon = ({ title }) => {
  const t = (title || '').toLowerCase();
  const type =
    t.includes('pil') || t.includes('battery') ? 'battery' :
    t.includes('model') || t.includes('karşılaştırma') ? 'devices' :
    t.includes('depolama') || t.includes('storage') ? 'storage' :
    t.includes('renk') || t.includes('tasarım') ? 'palette' :
    t.includes('sistem') || t.includes('yazılım') ? 'settings' :
    t.includes('garanti') || t.includes('belge') ? 'shield' :
    'info';

  const stroke = APPLE_THEME.metalicGray;
  const common = { fill: 'none', stroke, strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };

  return (
    <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden>
      {type === 'battery' && (
        <g {...common}>
          <rect x="2" y="7" width="18" height="10" rx="2" ry="2" />
          <line x1="22" y1="11" x2="22" y2="13" />
          <path d="M6 9v6" />
        </g>
      )}
      {type === 'devices' && (
        <g {...common}>
          <rect x="3" y="4" width="13" height="12" rx="2" />
          <path d="M9.5 20h9a1.5 1.5 0 0 0 1.5-1.5V8" />
        </g>
      )}
      {type === 'storage' && (
        <g {...common}>
          <rect x="3" y="4" width="18" height="6" rx="2" />
          <rect x="3" y="14" width="18" height="6" rx="2" />
        </g>
      )}
      {type === 'palette' && (
        <g {...common}>
          <path d="M12 21a9 9 0 1 1 8.66-11.5A3 3 0 0 1 18 12h-1a3 3 0 0 0-3 3 3 3 0 0 1-3 3H9" />
        </g>
      )}
      {type === 'settings' && (
        <g {...common}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06A2 2 0 1 1 7.04 3.6l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06A2 2 0 1 1 20.4 7.04l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c0 .66.38 1.27.98 1.55" />
        </g>
      )}
      {type === 'shield' && (
        <g {...common}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </g>
      )}
      {type === 'info' && (
        <g {...common}>
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
          <path d="M11 12h2v6h-2z" />
        </g>
      )}
    </svg>
  );
};

const BuyingGuide = () => {
  const { type } = useParams();
  const guide = buyingGuides[type];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  if (!guide) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h1 className="text-2xl" style={{ fontFamily: TYPOGRAPHY.hero }}>
          Rehber bulunamadı
        </h1>
      </div>
    );
  }

  const { title, description, sections = [] } = guide;

  return (
    <>
      <Header />
      <main className="min-h-screen bg-white pt-14">
        <section className="py-12 sm:py-16 md:py-20 relative overflow-hidden">
          <div
            className="absolute inset-0 opacity-60"
            style={{
              background: `radial-gradient(ellipse at top, ${APPLE_THEME.lightMetalicGray} 0%, transparent 55%)`
            }}
          />
          <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1
              className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4"
              style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero }}
            >
              {title}
            </h1>
            <p
              className="text-lg sm:text-xl"
              style={{ color: APPLE_THEME.textGray, fontFamily: TYPOGRAPHY.body, lineHeight: '1.5' }}
            >
              {description}
            </p>
          </div>
        </section>

        {sections.length > 0 && (
          <section className="pb-6 sm:pb-8 md:pb-10">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                {sections.map((s, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      const el = document.getElementById(`section-${i}`);
                      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }}
                    className="group text-left rounded-2xl p-5 sm:p-6 transition-all duration-300 border hover:shadow-md"
                    style={{ borderColor: APPLE_THEME.lightMetalicGray, backgroundColor: APPLE_THEME.white }}
                  >
                    <div className="flex items-start gap-4">
                      <div
                        className="flex items-center justify-center w-12 h-12 rounded-xl bg-white border"
                        style={{ borderColor: APPLE_THEME.lightMetalicGray }}
                      >
                        <SectionIcon title={s.title} />
                      </div>
                      <div>
                        <h3
                          className="text-base sm:text-lg font-semibold mb-1"
                          style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero }}
                        >
                          {s.title}
                        </h3>
                        <div className="flex items-center text-sm">
                          <span className="link-apple" style={{ color: APPLE_THEME.metalicGray, fontFamily: TYPOGRAPHY.body }}>
                            Daha fazla bilgi
                          </span>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="ml-1 opacity-80 group-hover:translate-x-0.5 transition-transform">
                            <path d="M8 4L16 12L8 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </section>
        )}

        <section className="py-8 sm:py-12">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-10 sm:space-y-12">
              {sections.map((section, index) => (
                <div key={index} id={`section-${index}`} className="scroll-mt-20">
                  <article
                    className="relative overflow-hidden rounded-2xl p-6 sm:p-8 border"
                    style={{ borderColor: APPLE_THEME.lightMetalicGray, backgroundColor: APPLE_THEME.white }}
                  >
                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-10">
                      <div className="flex-1 min-w-0">
                        <h2
                          className="text-2xl sm:text-3xl font-semibold mb-4"
                          style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero }}
                        >
                          {section.title}
                        </h2>
                        <div>
                          {(typeof section.content === 'string' ? section.content : `${section.content || ''}`)
                            .split('\n\n')
                            .map((paragraph, idx) => (
                              <p
                                key={idx}
                                className="mb-4 last:mb-0 text-base sm:text-lg"
                                style={{ color: APPLE_THEME.metalicGray, fontFamily: TYPOGRAPHY.body, lineHeight: '1.6' }}
                              >
                                {paragraph}
                              </p>
                            ))}
                        </div>

                        {Array.isArray(section.tips) && section.tips.length > 0 && (
                          <div className="mt-6">
                            <h3
                              className="text-lg font-semibold mb-3"
                              style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero }}
                            >
                              Önemli İpuçları
                            </h3>
                            <ul className="space-y-2">
                              {section.tips.map((tip, tipIndex) => (
                                <li key={tipIndex} className="flex items-start gap-2">
                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="mt-1">
                                    <path d="M20 6L9 17l-5-5" stroke={APPLE_THEME.darkMetalicGray} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                  <span style={{ color: APPLE_THEME.textGray, fontFamily: TYPOGRAPHY.body }}>{tip}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>

                      <div className="w-full lg:w-80 xl:w-96 self-stretch">
                        <div
                          className="h-40 sm:h-48 lg:h-full rounded-xl border"
                          style={{
                            borderColor: APPLE_THEME.lightMetalicGray,
                            background: `linear-gradient(135deg, ${APPLE_THEME.lightMetalicGray}, ${APPLE_THEME.backgroundGray})`
                          }}
                        />
                      </div>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 sm:py-14 border-t" style={{ borderColor: APPLE_THEME.lightMetalicGray }}>
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h3 className="text-2xl font-semibold mb-3" style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero }}>
              Daha fazla yardıma mı ihtiyacınız var?
            </h3>
            <p className="mb-6" style={{ color: APPLE_THEME.textGray, fontFamily: TYPOGRAPHY.body }}>
              Uzmanlarımız sizin için burada.
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <a
                href="/iletisim"
                className="px-5 py-3 rounded-full text-sm font-medium border transition-colors"
                style={{
                  borderColor: APPLE_THEME.lightMetalicGray,
                  color: APPLE_THEME.black,
                  fontFamily: TYPOGRAPHY.body
                }}
              >
                İletişime geçin
              </a>
              <a
                href="tel:+905382477373"
                className="px-5 py-3 rounded-full text-sm font-medium text-white"
                style={{
                  backgroundColor: APPLE_THEME.darkMetalicGray,
                  fontFamily: TYPOGRAPHY.body
                }}
              >
                Telefonla Destek
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default BuyingGuide;
